export const API_PATHS = {
  AUTH_LOGIN: "auth/login/",
  AUTH_REGISTER: "auth/register/",
  AUTH_LOGOUT: "auth/logout/",
  AUTH_VERIFICATION: "email/verify",

  PROFILE_INFO: "profile/",
  PROFILE_LOCATION: "/profile/location/",

  MESSAGES_LIST: "conversations",
  MESSAGES_SEND: "/send_message",

  TELEGRAM_LIST: "telegram-integrations",
  TELEGRAM_CREATE_CHANNEL: "/employees/create_with_telegram/",

  KNOWLEDGE_BASES: "knowledge-bases",
};
